module.exports = __webpack_public_path__ + "static/media/step-two-big.7ffac8fe.jpg";